// extracted by mini-css-extract-plugin
export default {"bottle":"Bottle_bottle__9zbP0"};